import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getServices, getSystemDefaults, getCryptoAddress, purchaseService, verifyPayment } from '../../api/endpoints/services'

export const useBrowseServices = () => {
  const qc = useQueryClient()
  
  // Get all available services for browsing/purchasing
  const services = useQuery({
    queryKey: ['browse-services'],
    queryFn: getServices
  })
  
  // Get system defaults including crypto address
  const systemDefaults = useQuery({
    queryKey: ['system-defaults'],
    queryFn: getSystemDefaults
  })
  
  // Get crypto address specifically
  const cryptoAddress = useQuery({
    queryKey: ['crypto-address'],
    queryFn: getCryptoAddress
  })
  
  const purchase = useMutation({
    mutationFn: (serviceId: number) => purchaseService(serviceId),
    onSuccess: () => {
      // Invalidate both browse services and user purchases
      qc.invalidateQueries({ queryKey: ['browse-services'] })
      qc.invalidateQueries({ queryKey: ['user-purchases'] })
      qc.invalidateQueries({ queryKey: ['services'] })
    }
  })
  
  const verify = useMutation({
    mutationFn: (sessionId: string) => verifyPayment(sessionId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['browse-services'] })
      qc.invalidateQueries({ queryKey: ['user-purchases'] })
      qc.invalidateQueries({ queryKey: ['services'] })
    },
  })
  
  return { 
    services, 
    systemDefaults, 
    cryptoAddress, 
    purchase, 
    verify 
  }
}
